import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M16.96812 1.15205 6.13214 4.75205C-1.15186 7.18805-1.15186 11.16 6.13214 13.584L9.34814 14.652 10.41612 17.868C12.84012 25.152 16.82412 25.152 19.24812 17.868L22.86012 7.04405C24.46812 2.18405 21.82812-.46795 16.96812 1.15205ZM17.35212 7.60805 12.79212 12.192C12.61212 12.372 12.38412 12.456 12.15612 12.456 11.92812 12.456 11.70012 12.372 11.52012 12.192 11.35272 12.02268 11.25888 11.7942 11.25888 11.556 11.25888 11.31792 11.35272 11.08944 11.52012 10.92L16.08012 6.33605C16.42812 5.98805 17.00412 5.98805 17.35212 6.33605 17.70012 6.68405 17.70012 7.26005 17.35212 7.60805Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }